import React from "react";
import PropTypes from "prop-types";
import filterTypes from "data/filter-types";
import SelectFilter from "views/lib/components/filter/select-filter";
import { DatePicker } from "antd";
import moment from "moment";
import SearchSelect from "views/lib/components/SearchSelect";

const { RangePicker } = DatePicker;

class FilterItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: this.props.name,
      value: this.props.value || "",
      placeholder: this.props.placeholder,
      filterType: this.props.filterType,
      filter: {}
    };

    this.getFilterType = this.getFilterType.bind(this);
    this.handleChangeFilterType = this.handleChangeFilterType.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.sendParent = this.sendParent.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value) {
      this.setState({
        value: nextProps.value
      });
    }
  }

  getFilterType = () => {
    const {
      searchOperation,
      filterTypeOptions,
      exitsTypeOptions
    } = this.props;
    const {
      name,
      value,
      placeholder,
      filterType,
      filter
    } = this.state;
    let options,
      currentValue;
    const widthClassName = searchOperation.length > 1 ? "w-75" : "w-100";

    switch (filterType) {
      case "text":
      case "number":
      case "email":
        return (
          <input
            className={`form-control form-control-sm ${widthClassName}`}
            type={filterType}
            name={name}
            placeholder={placeholder}
            onChange={this.handleChangeInput}
            value={value}
          />
        );
      case "date":
        return (
          <DatePicker
            format="YYYY-MM-DD"
            onChange={date => this.handleChangeInput({
              target: {
                name,
                value: date ? moment(date)
                  .valueOf() : null
              }
            })}
            className={`d-block ${widthClassName}`}
            placeholder={placeholder}
            value={value ? moment(value) : null}
          />
        );
      case "date_range":
        return (
          <RangePicker
            format="YYYY-MM-DD"
            onChange={date => {
              this.handleChangeInput({
                target: {
                  name,
                  value: date
                }
              });
            }}
            className={`d-block ${widthClassName}`}
            placeholder={placeholder}
            value={value || null}
          />
        );
      case "select":
      case "select_multiple":
        options = [];
        if (filterType !== "select_multiple") {
          options.push({
            label: "All",
            value: ""
          });
        }
        filterTypeOptions.forEach(option => {
          options.push(option);
        });

        if (filter
          && filter.searchOperation
          && filter.searchOperation === filterTypes.EXIST.value
          && exitsTypeOptions.length
        ) {
          options = [];
          exitsTypeOptions.forEach(option => {
            options.push(option);
          });
        }

        if (Array.isArray(value)) {
          currentValue = [];
          value.forEach(item => {
            options.forEach(option => {
              if (item === option.value) {
                currentValue.push(option);
              }
            });
          });
        } else {
          currentValue = null;
          options.forEach(option => {
            if (value !== "" && value === option.value) {
              currentValue = option;
            }
          });
        }

        return (
          <div className={widthClassName}>
            <SearchSelect
              className="search-select"
              onChange={(option) => {
                let value;
                if (option && Array.isArray(option)) {
                  value = option.map(item => item.value);
                } else {
                  value = option.value;
                }
                this.handleChangeInput({
                  target: {
                    name,
                    value
                  }
                });
              }}
              name={name}
              placeholder={placeholder}
              options={options}
              isSearchable={true}
              isClearable={false}
              isLoading={false}
              isMulti={filterType === "select_multiple"}
              value={currentValue}
            />
          </div>
        );
      default:
        return null;
    }
  };

  handleChangeFilterType = (ev, defaultValue) => {
    const {
      name: fieldName,
      value: searchOperation
    } = ev.target;
    let filter = Object.assign({}, this.state.filter);
    if (Object.keys(filter).length) {
      filter.searchOperation = searchOperation;
    } else {
      filter = {
        fieldName,
        fieldValue: defaultValue,
        searchOperation,
      };
    }
    if (searchOperation === filterTypes.IN.value) {
      filter.fieldValue = Array.isArray(filter.fieldValue)
        ? filter.fieldValue
        : [filter.fieldValue];
    } else {
      filter.fieldValue = Array.isArray(filter.fieldValue)
        ? filter.fieldValue[0]
        : filter.fieldValue;
    }

    let filterType = this.props.filterType;
    if (searchOperation === filterTypes.IN.value) {
      filterType = "select_multiple";
    } else if (searchOperation === filterTypes.EXIST.value) {
      filterType = "select";
    }

    this.setState({
      filterType,
      filter
    }, this.sendParent);
  };

  handleChangeInput = (ev) => {
    const { searchOperation } = this.props;
    const {
      name,
      value
    } = ev.target;
    let filter = Object.assign({}, this.state.filter);
    if (value === "" || value === null) {
      filter = {};
    } else if (Array.isArray(value) && !value.length) {
      filter = {};
    } else if (Object.keys(filter).length) {
      filter.fieldValue = value;
    } else {
      filter = {
        fieldName: name,
        fieldValue: value,
        searchOperation: searchOperation.length ? searchOperation[0] : filterTypes.EQUALS.value
      };
    }

    this.setState({
      value,
      filter
    }, this.sendParent);
  };

  sendParent = () => {
    const { name } = this.props;
    const { filter } = this.state;
    this.props.onChange(name, filter);
  };

  render() {
    const {
      name,
      searchOperation,
      defaultValue,
      defaultFilterType
    } = this.props;

    const inputComponent = this.getFilterType();

    return (
      <div className="input-group">
        {inputComponent}
        <SelectFilter
          name={name}
          onChange={this.handleChangeFilterType}
          defaultValue={defaultValue}
          defaultFilterType={defaultFilterType || false}
          filters={searchOperation.length ? searchOperation : [filterTypes.EQUALS.value]}
        />
      </div>
    );
  }
}

FilterItem.defaultProps = {
  searchOperation: [],
  filterTypeOptions: [],
  exitsTypeOptions: [],
  defaultValue: "",
  defaultFilterType: false,
  value: ""
};

FilterItem.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  defaultValue: PropTypes.any,
  defaultFilterType: PropTypes.any, // filter operation default
  value: PropTypes.any,
  filterType: PropTypes.oneOf([
    "text",
    "number",
    "email",
    "select",
    "select_multiple",
    "date",
    "date_range"
  ]).isRequired,
  filterTypeOptions: PropTypes.array,
  exitsTypeOptions: PropTypes.array,
  searchOperation: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
};

export default FilterItem;



// WEBPACK FOOTER //
// ./src/views/lib/components/filter/filter-item.js